import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { BsFillPersonLinesFill, BsWhatsapp } from "react-icons/bs";
import { profile } from "../data/profile";

const SocialLinks = () => {
  const links = [
    { id: 1, child: <>LinkedIn <FaLinkedin size={30} /></>, href: profile.links.linkedin, style: "rounded-tr-md" },
    { id: 2, child: <>GitHub <FaGithub size={30} /></>, href: profile.links.github },
    { id: 3, child: <>WhatsApp <BsWhatsapp size={30} /></>, href: profile.links.whatsapp },
    { id: 4, child: <>Resume <BsFillPersonLinesFill size={30} /></>, href: profile.resume, style: "rounded-br-md" },
  ];

  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed z-40">
      <ul>
        {links.map(({ id, child, href, style = "" }) => (
          <li
            key={id}
            className={`flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-500 ${style}`}
          >
            <a
              href={href}
              className="flex justify-between items-center w-full text-white"
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
